import { match } from 'react-router'

export function buildPath<T extends { [K in keyof T]?: string }>(match: match<T>, path: string) {
  return `${match.path}${path}`
}
